import {
  FileTextOutlined,
  FileUnknownOutlined,
  FolderOutlined
} from '@ant-design/icons';
import { message, Typography } from 'antd';
import { ProcedureBridgeApi } from 'client/components/schema/procedure-bridge/ProcedureBridgeApi';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import { IRequest } from 'common/schema/request/Request';
import { RequestLogic } from 'common/schema/RequestLogic';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const { Text } = Typography;

interface RequestDocumentDetailLinkProps {
  request: IRequest;
}

export function RequestDocumentDetailLink(
  props: RequestDocumentDetailLinkProps
) {
  const { request } = props;
  const id = request.id;

  const { response, loading, error } = useApiQuery(
    ProcedureBridgeApi.getDocumentToken,
    {
      skip: id == null || RequestLogic.isDossierTypeEach(request),
      data: {
        requestId: id!
      }
    }
  );

  const token = response?.data.token ?? null;

  const detailLink = RequestLogic.isDossierTypeEach(request)
    ? { pathname: `/richieste/${id}/dettaglio/fascicolo` }
    : {
        pathname: `/richieste/${id}/dettaglio/documento`,
        state: { token }
      };

  const isDossier = RequestLogic.isDossierTypeEach(request);

  const subjectString = isDossier ? 'Fascicolo' : 'Documento';

  if (!request || loading)
    return <LoaderSpin transparent style={{ margin: '-30px' }} />;

  if (error) {
    return (
      <span
        style={{ fontSize: '20px' }}
        onClick={() =>
          message.warning(
            `${subjectString} al momento non consultabile. Riprovare più tardi.`
          )
        }
      >
        <FileUnknownOutlined key="setting" />
        <Text>{`${subjectString} non consultabile`}</Text>
      </span>
    );
  }

  return (
    <Link to={detailLink} style={{ fontSize: '20px' }}>
      {isDossier ? (
        <FolderOutlined style={{ marginRight: '5px' }} />
      ) : (
        <FileTextOutlined style={{ marginRight: '5px' }} />
      )}
      {`Visualizza ${subjectString}`}
    </Link>
  );
}
